import ApiService from "./ApiService";

const { REACT_APP_APILOGIN } = process.env;

const FacebookAcountService =
{
    AsociarFacebook: function (data) {
        return ApiService.post(`${REACT_APP_APILOGIN}Usuario/AsociarFacebook`, data);
    },
    DesasociarFacebook: function () {
        return ApiService.post(`${REACT_APP_APILOGIN}Usuario/DesasociarFacebook`);
    },
}
export default FacebookAcountService;